/**
 * Type of buttons for Quantcast Consent Manager.
 *
 * @type {string}
 */
export const GDPR = `GDPR`;
export const USP = `USP`;
